import { NavSettingsButton as Button } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { Tools } from '~map-preview/App/Layout/Nav/Tools'
import { useAuth } from 'user-auth'

export function Settings() {
  const { sideBar, setSideBar, setOpenDrawer, setOpenMenu } = useMapNavStore()
  const { authenticated } = useAuth()

  const handleClick = () => {
    setSideBar(Tools.settings.key)
    setOpenDrawer(true)
    setOpenMenu(false)
  }

  if (!authenticated) {
    return null
  }

  return (
    <Button
      selected={sideBar === Tools.settings.key}
      onClick={handleClick}
    />
  )
}
